const add = "minimal";

const Select = ({ className, ...props }) => (
  <select className={add} {...props} />
);

export default Select;
